import {getItems} from './local-storage'

// TODO: these should come from configuration instead
const LEVELS = [
  {level: 1, stars: 0, title: 'Aloittelija'},
  {level: 2, stars: 38, title: 'Tietäjä'},
  {level: 3, stars: 76, title: 'Kierrätyksen sankari'},
]

export function getPlayerInfo () {
  const starsItems = getItems(key => key.match(/.*stars$/))
  const stars = Object.values(starsItems).reduce((sum, value) => sum + (Number(value || 0) || 0), 0)
  const level = [...LEVELS].reverse().find(({stars: requiredStars}) => stars >= requiredStars)
  const nextLevel = LEVELS.find(({stars: requiredStars}) => stars < requiredStars)
  return {
    name: 'Pökkelö',
    level: level.level,
    description: level.title,
    stars,
    prevStars: level.stars,
    nextStars: nextLevel ? nextLevel.stars : undefined,
  }
}
